
import { defineComponent } from "vue";
import GameButton from "@/components/GameButton.vue";

export default defineComponent({
  name: "ActionButton",

  components: {
    GameButton,
  },

  data() {
    return {
      flyOutText: "Flyout",
      lastLabel: "",
      flyOutTriggered: false,
      flyOutTimeout: 0,
    };
  },

  props: {
    label: {
      type: String,
    },
    alternative: {
      type: String,
      default: "",
    },
    isLarge: {
      type: Boolean,
    },
    isBorderless: {
      type: Boolean,
    },
    hasFlyOut: {
      type: Boolean,
    },
    flyOutTrigger: {
      type: Number,
    },
  },

  computed: {
    flyOutClass() {
      return {
        "action-button__flyout--large":
          this.isLarge && this.alternative.length <= 2,
        "action-button__flyout--large-small-alt":
          this.isLarge && this.alternative.length > 2,
      };
    },
    showFlyOut() {
      return this.hasFlyOut && this.flyOutTriggered;
    },
  },

  methods: {},

  watch: {
    label(newVal, oldVal) {
      if (oldVal) this.lastLabel = oldVal;
    },
    flyOutTrigger() {
      clearTimeout(this.flyOutTimeout);
      this.flyOutTimeout = 0;
      this.flyOutTriggered = true;
      this.flyOutTimeout = setTimeout(() => {
        this.flyOutTriggered = false;
      }, 500);
    },
  },
});
